import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import BackgroundPicker from '../widgets/BackgroundPicker';
import { convertRGBAToHexColor, splitRGBAValues } from '../pages/theme/theme-utils';

class PresetColorPicker extends Component {
    state = {
        displayColorPicker: false
    };

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false });
    };

    handleChange = color => {
        const { convertToHex = false } = this.props;
        const updatedColor =
            convertToHex && color.startsWith('rgb') ? convertRGBAToHexColor(splitRGBAValues(color)) : color;
        this.props.onColorChange({ target: { value: updatedColor } });
    };

    render() {
        const color = (this.props.color || '').replace(/\s/g, '');

        return (
            <BackgroundPicker
                background={color}
                preset={this.props.primary.colors}
                onChange={this.handleChange}
                isDisabled={this.props.isDisabled}
                hideImageSelector
            />
        );
    }
}

PresetColorPicker.propTypes = {
    color: PropTypes.string,
    onColorChange: PropTypes.func
};

const mapStateToProps = state => {
    return {
        ...state.app.data.theme.colors,
        ...state.theme.colors,
        background: state.app.data.theme.colors.background
    };
};

export default connect(mapStateToProps)(PresetColorPicker);



// WEBPACK FOOTER //
// ./src/components/widgets/PresetColorPicker.js